import { Component, OnInit } from '@angular/core';

import { SubHeader } from '../../../core/models/sub-header.model';
import { SubHeaderService } from '../../../core/services/sub-header.service';

@Component({
    selector: 'app-chief-orders',
    templateUrl: './chief-orders.component.html',
    styleUrls: ['./chief-orders.component.scss'],
    standalone: false
})
export class ChiefOrdersComponent implements OnInit {

  subHeader = new SubHeader({
    title: "Chief's Orders", buttons: []
  });

  constructor(public subHeaderService: SubHeaderService) { }

  ngOnInit() {
    this.subHeaderService.updateSubHeader(this.subHeader);
  }

}
